import { SvgIcon, SxProps } from "@mui/material";
import PenToSquare from "jsx:../../../Images/Icons/FontAwesome/light/pen-to-square.svg";

export function EditIcon(props: SxProps) {
    return <SvgIcon component={PenToSquare} inheritViewBox sx={props} />;
}
